import { Component, ErrorInfo } from "react";

class ErrorBoundary extends Component<any, any> {
  constructor(props: any) {
    super(props)

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI
    window.dataLayer?.push({
      event: "clientError",
      error,
    });
    return { hasError: true };
  }

  componentDidCatch(error: any, info: ErrorInfo) {
    // You can use your own error logging service here
    window.dataLayer?.push({
      event: "clientError",
      error,
      info: info.componentStack,
    });
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <div className="flex flex-col justify-center items-center w-full h-[50vh] px-6 text-4xl font-semibold gap-8">404
            <h2>Oops, there is an error!</h2>
            <button type="button" className="btn-primary" onClick={() => this.setState({ hasError: false })}>
              Try again?
            </button>
          </div>
        </div>
      )
    }

    // Return children components in case of no error
    return this.props.children;
  }
}

export default ErrorBoundary;